"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = exports.DetailText = exports.CardDetails = exports.Container = void 0;
const tslib_1 = require("tslib");
const theme_1 = require("@monorepo/theme");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
exports.Container = styled_components_1.default.section `
  position: relative;
  max-width: ${({ width }) => (width ? width : 454)}px;
  max-height: ${({ height }) => (height ? height : 531)}px;

  box-shadow: 0 0 1em 1px rgba(0, 0, 0, 0.15);

  display: flex;
  flex-direction: column;
  flex: 1 1 300px;

  margin: 1rem 0;
  @media (max-width: 930px) {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
`;
exports.CardDetails = styled_components_1.default.div `
  padding: 1em 1.3em 1.2em 1.3em;

  display: flex;
  flex-direction: column;
  gap: 11px;
`;
exports.DetailText = styled_components_1.default.p `
  margin: 0.5rem 0;
  font-size: 1rem;
  font-weight: 400;
  color: ${theme_1.colors.black};
`;
exports.Link = styled_components_1.default.a `
  width: fit-content;
  height: 21px;
  font-size: 15px;
  font-weight: bold;
  box-shadow: inset 0 -0.09em #7ceadb;

  &:hover {
    color: gray;
  }
`;
